import { defaultOperators, toValue } from "liquidjs";

export default {
  ...defaultOperators,

  // Pin the `contains` operator until the fix this regression: https://github.com/harttle/liquidjs/issues/675
  contains: (l: any, r: any): boolean => {
    l = toValue(l);
    r = toValue(r);
    return l && typeof l.indexOf === "function" ? l.indexOf(r) > -1 : false;
  },
};
